<template>
  <!-- 组卷弹框 -->
  <el-dialog
    class="akadm-dialog-modal akadm-third-partner"
    title="账号绑定提示"
    :visible.sync="visible"
    :close-on-click-modal="false"
    @close="closeModal"
  >
    <p class="bind-text">
      是否绑定{{ third_partner_name }}账号同步登录爱米云助教？
    </p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeModal" class="cancle-btn">暂不绑定</el-button>
      <el-button type="primary" @click="sureModal">立即绑定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import * as Api from "./indexApi";
export default {
  name: "bindThirdPartner",
  data() {
    return {
      visible: false,
      third_partner_name: "",
    };
  },
  watch: {
    $route(to, from) {
      this.visible =
        localStorage.getItem("is_bind_third_user") == "true" ? true : false;
      this.third_partner_name = localStorage.getItem("third_partner_name");
    },
  },
  methods: {
    closeModal() {
      localStorage.setItem("is_bind_third_user", false);
      this.visible = false;
    },
    sureModal() {
      this.bindAccount();
    },
    bindAccount() {
      let data = {
        token: localStorage.getItem("third_partner_token"),
      };
      this.$loading.show();
      Api.thirdPartnerBind(data)
        .then((res) => {
          this.$loading.hide();
          if (res.errCode == 0) {
            this.closeModal();
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.closeModal();
          throw new Error(err);
        })
        .finally(() => {});
    },
  },
  mounted() {},
  created() {},
};
</script>

<style lang="scss" >
.akadm-third-partner .el-dialog {
  width: 486px !important;
  .el-dialog__title {
    position: relative;
    padding-left: 34px;
    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
      background: url("~@/assets/images/info_tips.svg") no-repeat left center;
    }
  }
  .cancle-btn {
    background: #fafafa !important;
  }
  .bind-text {
    font-size: 16px;
    margin-bottom: 24px;
  }
}
</style>
